import I18n from 'i18n-js';
import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import Button from '../generic/Button.js';
import Icon from '../generic/Icon.js';

const useStyles = makeStyles((theme) => ({
  row: {
    paddingBlock: theme.spacing(1),
  },
  icon: {
    fill: theme.palette.secondary.contrastText,
  },
}));

const PipOverlay = ({ onEvent, environment, docPip }) => {
  const classes = useStyles();

  const togglePip = () => {
    if (Boolean(docPip)) {
      docPip.close();
    } else {
      onEvent({ type: 'toggle_pip' });
    }
  };

  return (
    <div id="pip-overlay">
      <Typography variant="h6" className={classes.row}>
        {I18n.t('pip_mode_text:header')}
      </Typography>
      <Typography variant="body2" className={classes.row}>
        {I18n.t('pip_mode_text:description')}
      </Typography>
      {environment.canPip && (
        <div className={classes.row}>
          <Button onClick={togglePip}>
            <Icon type="pip_off" className={classes.icon}></Icon>
            {I18n.t('pip_mode_text:back_button')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default PipOverlay;
